/**************************************************
 * Nombre:       ListaProductos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import TarjetaProducto from "../../../Tarjetas/TarjetaProducto";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const ListaProductos = ({items, cargaMas}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 3}}
                spacing={sCell ? 8 : 12}
            >

                {items.map((e, i) => (
                    <Grid container key={`Rs${i}`} size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                        <TarjetaProducto item={e}/>
                    </Grid>
                ))}

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Button
                        onClick={() => cargaMas()}
                        variant="outlined"
                    >Cargar Mas</Button>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default ListaProductos

